(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-details"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('volt-product-overview')) {
  customElements.define('volt-product-overview', class extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      this.viewport = this.querySelector('.volt-overview__viewport');
      this.content = this.querySelector('[data-volt-description]');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.update = () => {
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--volt-overview-height')) || 320;
        const overflows = this.content.getBoundingClientRect().height > limit + 1;
        this.classList.toggle('is-collapsible', overflows);
        this.button.hidden = !overflows;
        this.updateFocus();
      };
      this.updateFocus = () => {
        const clipped = this.classList.contains('is-collapsible') && !this.classList.contains('is-expanded');
        const bottom = this.viewport.getBoundingClientRect().bottom;
        this.content.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => {
          const hidden = clipped && el.getBoundingClientRect().bottom > bottom;
          if (hidden && !el.hasAttribute('data-overview-tabindex')) {
            el.dataset.overviewTabindex = el.getAttribute('tabindex') ?? '';
            el.setAttribute('tabindex', '-1');
          } else if (!hidden && el.hasAttribute('data-overview-tabindex')) {
            const value = el.dataset.overviewTabindex;
            if (value === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', value);
            delete el.dataset.overviewTabindex;
          }
        });
      };
      this.onToggle = () => {
        const expanded = this.classList.toggle('is-expanded');
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.querySelector('span').textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        this.updateFocus();
        if (!expanded && this.getBoundingClientRect().bottom < 0) this.scrollIntoView({ block: 'start' });
      };
      this.button.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.content);
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.button?.removeEventListener('click', this.onToggle); this.button = null; }
  });
}


(() => {
  const normalizeDescriptions = (scope = document) => {
    scope.querySelectorAll('[data-volt-description]:not([data-normalized])').forEach(root => {
      root.dataset.normalized = 'true';
      root.querySelectorAll('h1,h2,h3,h4,p,li').forEach(el => {
        while (el.firstChild && (el.firstChild.nodeName === 'BR' || (el.firstChild.nodeType === 3 && !el.firstChild.textContent.trim()))) el.firstChild.remove();
        if (!el.textContent.trim() && !el.querySelector('img,video,iframe,audio,svg')) el.remove();
      });
      root.querySelectorAll('li').forEach(li => {
        if (li.children.length === 1 && li.firstElementChild.tagName === 'P') li.firstElementChild.replaceWith(...li.firstElementChild.childNodes);
      });
      const candidates = [...root.children].filter(el => /^H[2-4]$/.test(el.tagName) && /^(UL|OL)$/.test(el.nextElementSibling?.tagName || ''));
      if (candidates.length < 3) return;
      let grid = null;
      candidates.forEach(heading => {
        const list = heading.nextElementSibling;
        if (!grid || grid.nextElementSibling !== heading) {
          grid = document.createElement('div'); grid.className = 'volt-description__groups'; heading.before(grid);
        }
        const group = document.createElement('section'); group.className = 'volt-description__group';
        group.append(heading, list); grid.append(group);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => normalizeDescriptions());
  else normalizeDescriptions();
  document.addEventListener('shopify:section:load', event => normalizeDescriptions(event.target));
  let active = null;
  const close = () => {
    if (!active) return;
    document.getElementById(active.getAttribute('aria-describedby'))?.setAttribute('hidden', '');
    active.setAttribute('aria-expanded', 'false');
    active = null;
  };
  const show = (button) => {
    if (active === button) return;
    close();
    const tooltip = document.getElementById(button.getAttribute('aria-describedby'));
    if (!tooltip) return;
    tooltip.hidden = false;
    const rect = button.getBoundingClientRect();
    const box = tooltip.getBoundingClientRect();
    tooltip.style.left = `${Math.max(12, Math.min(rect.left, window.innerWidth - box.width - 12))}px`;
    tooltip.style.top = `${rect.bottom + box.height + 16 < window.innerHeight ? rect.bottom + 8 : Math.max(12, rect.top - box.height - 8)}px`;
    button.setAttribute('aria-expanded', 'true');
    active = button;
  };
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const button = event.target.closest('.volt-spec-help__button');
    if (button) show(button);
  });
  document.addEventListener('pointerout', (event) => {
    if (!active || event.pointerType === 'touch') return;
    const wrapper = active.closest('.volt-spec-help');
    if (wrapper.contains(event.target) && !wrapper.contains(event.relatedTarget)) close();
  });
  document.addEventListener('focusin', (event) => {
    const button = event.target.closest('.volt-spec-help__button');
    if (button && button.matches(':focus-visible')) show(button);
  });
  document.addEventListener('focusout', (event) => { if (event.target === active) close(); });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.volt-spec-help__button');
    if (button) { if (active === button && event.detail !== 0) close(); else show(button); }
    else if (!event.target.closest('.volt-spec-help')) close();
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  window.addEventListener('resize', close);
  window.addEventListener('scroll', close, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-brand"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const localize = (root) => {
      root.querySelectorAll('[data-product-brand-country]').forEach((element) => {
        try {
          const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
          let code = element.dataset.productBrandCountry;
          if (!/^[A-Z]{2}$/.test(code)) {
            const english = new Intl.DisplayNames(['en'], { type: 'region' });
            const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '');
            const target = normalize(code);
            code = '';
            for (let first = 65; first <= 90 && !code; first++) {
              for (let second = 65; second <= 90; second++) {
                const candidate = String.fromCharCode(first, second);
                const label = names.of(candidate);
                if (label !== candidate && target && (normalize(label) === target || normalize(english.of(candidate)) === target)) {
                  code = candidate;
                  break;
                }
              }
            }
          }
          if (code) {
            element.querySelector('[data-product-brand-country-name]').textContent = names.of(code) || code;
            element.querySelector('[data-product-brand-flag]').textContent = String.fromCodePoint(
              ...Array.from(code, (letter) => 127397 + letter.charCodeAt(0))
            );
          }
        } catch (_) {}
      });
    };
    localize(document);
    document.addEventListener('shopify:section:load', (event) => localize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-picks"]) return;
  try {
    
  if (!customElements.get('volt-discount-code')) {
    customElements.define('volt-discount-code', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const button = this.querySelector('[data-copy-button]');
        const input = this.querySelector('input');
        const status = this.querySelector('[role="status"]');
        const label = button.textContent;
        button.addEventListener('click', async () => {
          button.disabled = true;
          let copied = false;
          try {
            await navigator.clipboard.writeText(input.value);
            copied = true;
          } catch (error) {
            input.focus();
            input.select();
            try { copied = document.execCommand('copy'); } catch (fallbackError) {}
          }
          if (!this.isConnected) return;
          button.disabled = false;
          button.textContent = copied ? this.dataset.copiedLabel : label;
          status.textContent = copied ? this.dataset.copiedLabel : this.dataset.errorLabel;
          clearTimeout(this.timer);
          if (copied) this.timer = setTimeout(() => {
            button.textContent = label;
            status.textContent = '';
          }, 2500);
        }, { signal: this.controller.signal });
        input.addEventListener('focus', () => input.select(), { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volt-event-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('volt-event-list')) {
  customElements.define('volt-event-list', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.abort) return;
        this.abort = new AbortController();
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {timeZone:'Europe/Amsterdam', weekday:'short', day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit', hourCycle:'h23'});
        this.querySelectorAll('[data-ve-time]').forEach(time => {
          const date = new Date(time.dateTime);
          if (Number.isFinite(date.getTime())) time.textContent = formatter.format(date);
        });
        const dayFormat = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Amsterdam', year:'numeric', month:'2-digit', day:'2-digit'});
        const dayNumber = date => {
          const parts = Object.fromEntries(dayFormat.formatToParts(date).map(part => [part.type, part.value]));
          return Date.UTC(+parts.year, +parts.month - 1, +parts.day) / 86400000;
        };
        const refreshCountdowns = () => {
          const today = dayNumber(new Date());
          this.querySelectorAll('[data-ve-card]').forEach(card => {
            const date = new Date(card.dataset.veDate);
            const pill = card.querySelector('[data-ve-pill]');
            if (!pill || !Number.isFinite(date.getTime())) return;
            const days = dayNumber(date) - today;
            pill.textContent = days < 0 ? this.dataset.past : days === 0 ? this.dataset.today : days === 1 ? this.dataset.tomorrow : this.dataset.days.replace('{count}', String(days));
            pill.classList.toggle('ve-pill--soon', days > 0 && days <= 7);
            pill.classList.toggle('ve-pill--today', days === 0);
          });
        };
        refreshCountdowns();
        this.countdownTimer = setInterval(refreshCountdowns, 60000);

      });
    }
    disconnectedCallback() { clearInterval(this.countdownTimer); this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volt-events"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('volt-events')) {
    customElements.define('volt-events', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected && !this.controller) this.init(); });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearInterval(this.timer);
        if (this.blobURL) URL.revokeObjectURL(this.blobURL);
      }
      init() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.zone = this.dataset.timezone || 'Europe/Amsterdam';
        try { new Intl.DateTimeFormat('en', { timeZone: this.zone }).format(); }
        catch { this.zone = 'Europe/Amsterdam'; }
        this.locale = document.documentElement.lang || 'en';
        this.dateFormat = new Intl.DateTimeFormat(this.locale, { timeZone: this.zone, weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
        this.dayFormat = new Intl.DateTimeFormat('en-CA', { timeZone: this.zone, year: 'numeric', month: '2-digit', day: '2-digit' });
        this.cards = [...this.querySelectorAll('[data-ve-card]')];
        this.filter = '';
        this.pastLimit = Number(this.dataset.pastLimit) || 6;
        this.visiblePast = this.pastLimit;
        this.upcoming = this.querySelector('[data-ve-upcoming]');
        this.past = this.querySelector('[data-ve-past]');
        this.dialog = this.querySelector('[data-ve-dialog]');
        this.addEventListener('click', event => {
          const filter = event.target.closest('[data-ve-filter]');
          if (filter) { this.filter = filter.dataset.veFilter; this.refresh(); }
          if (event.target.closest('[data-ve-reset]')) { this.filter = ''; this.refresh(); this.querySelector('[data-ve-filter]')?.focus(); }
          if (event.target.closest('[data-ve-more]')) {
            const first = this.past.querySelector('[data-ve-card][hidden]');
            this.visiblePast += this.pastLimit;
            this.refresh();
            if (first) { const title = first.querySelector('h3'); title.tabIndex = -1; title.focus({ preventScroll: true }); }
          }
          const calendar = event.target.closest('[data-ve-calendar]');
          if (calendar) this.openCalendar(calendar.closest('[data-ve-card]'));
          if (event.target.closest('[data-ve-close]') || event.target === this.dialog) this.dialog.close();
        }, { signal });
        this.refresh();
        this.timer = setInterval(() => this.refresh(), 60000);
        this.loadRemaining(signal);
      }
      dayNumber(date) {
        const parts = Object.fromEntries(this.dayFormat.formatToParts(date).map(p => [p.type, p.value]));
        return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 86400000;
      }
      eventDate(raw) {
        if (/[zZ]$|[+-]\d{2}:?\d{2}$|UTC$/.test(raw)) return new Date(raw);
        const parts = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
        if (!parts) return new Date(NaN);
        const wall = Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], +(parts[6] || 0));
        const formatter = new Intl.DateTimeFormat('en-CA', { timeZone: this.zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        let instant = wall;
        for (let i = 0; i < 3; i++) {
          const p = Object.fromEntries(formatter.formatToParts(new Date(instant)).map(p => [p.type, p.value]));
          const displayed = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
          instant += wall - displayed;
        }
        return new Date(instant);
      }
      refresh() {
        const now = new Date();
        const today = this.dayNumber(now);
        const upcoming = [], past = [];
        for (const card of this.cards) {
          const date = this.eventDate(card.dataset.veDate);
          if (!Number.isFinite(date.getTime())) { card.hidden = true; continue; }
          card.veDate = date;
          const days = this.dayNumber(date) - today;
          const isPast = days < 0;
          (isPast ? past : upcoming).push(card);
          const time = card.querySelector('[data-ve-time]');
          time.textContent = this.dateFormat.format(date);
          time.dateTime = date.toISOString();
          const pill = card.querySelector('[data-ve-pill]');
          if (pill) {
            pill.textContent = isPast ? this.dataset.past : days === 0 ? this.dataset.today : days === 1 ? this.dataset.tomorrow : this.dataset.days.replace('{count}', String(days));
            pill.classList.toggle('ve-pill--today', days === 0);
            pill.classList.toggle('ve-pill--soon', days > 0 && days <= 7);
          }
          card.classList.toggle('ve-card--past', isPast);
          card.classList.remove('ve-card--hero');
          const calendar = card.querySelector('[data-ve-calendar]');
          if (calendar) calendar.hidden = date <= now;
        }
        upcoming.sort((a, b) => a.veDate - b.veDate || a.dataset.veId.localeCompare(b.dataset.veId));
        past.sort((a, b) => b.veDate - a.veDate || a.dataset.veId.localeCompare(b.dataset.veId));
        this.updateFilters(upcoming);
        const shown = upcoming.filter(card => !this.filter || card.dataset.veType === this.filter);
        const hero = this.dataset.showHero === 'true' ? shown.find(card => card.dataset.veFeatured === 'true') || shown[0] : null;
        const ordered = hero ? [hero, ...upcoming.filter(card => card !== hero)] : upcoming;
        for (const card of ordered) { card.hidden = !shown.includes(card); card.classList.toggle('ve-card--hero', card === hero); }
        this.syncOrder(this.upcoming, ordered);
        past.forEach((card, index) => { card.hidden = index >= this.visiblePast; });
        this.syncOrder(this.past, past);
        this.querySelector('[data-ve-upcoming-count]').textContent = String(shown.length);
        this.querySelector('[data-ve-past-count]').textContent = String(past.length);
        this.querySelector('[data-ve-empty]').hidden = upcoming.length > 0;
        this.querySelector('[data-ve-noresults]').hidden = !upcoming.length || !!shown.length;
        const archive = this.querySelector('[data-ve-archive]');
        archive.hidden = archive.dataset.enabled !== 'true' || !past.length;
        this.querySelector('[data-ve-more]').hidden = past.length <= this.visiblePast;
      }
      syncOrder(parent, cards) {
        cards.forEach((card, index) => { if (parent.children[index] !== card) parent.insertBefore(card, parent.children[index] || null); });
      }
      updateFilters(cards) {
        const holder = this.querySelector('[data-ve-filters]');
        if (!holder) return;
        const types = [...new Set(cards.map(card => card.dataset.veType).filter(Boolean))].sort();
        if (this.filter && !types.includes(this.filter)) this.filter = '';
        const existing = new Map([...holder.querySelectorAll('[data-ve-filter]')].map(button => [button.dataset.veFilter, button]));
        for (const type of types) {
          if (existing.has(type)) continue;
          const button = document.createElement('button');
          button.type = 'button'; button.className = 've-chip'; button.dataset.veFilter = type; button.textContent = type;
          holder.append(button);
        }
        for (const button of holder.querySelectorAll('[data-ve-filter]')) {
          if (button.dataset.veFilter && !types.includes(button.dataset.veFilter)) { button.remove(); continue; }
          const selected = button.dataset.veFilter === this.filter;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        }
        holder.hidden = types.length < 2;
      }
      async loadRemaining(signal) {
        let next = this.querySelector('[data-ve-next]')?.href;
        const visited = new Set();
        try {
          while (next && !visited.has(next)) {
            visited.add(next);
            const response = await fetch(next, { signal });
            if (!response.ok) throw new Error('Events unavailable');
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            const section = document.getElementById(this.id);
            if (!section) throw new Error('Events section missing');
            const known = new Set(this.cards.map(card => card.dataset.veId));
            for (const card of section.querySelectorAll('[data-ve-card]')) {
              if (!known.has(card.dataset.veId)) { this.cards.push(card); known.add(card.dataset.veId); }
            }
            next = section.querySelector('[data-ve-next]')?.getAttribute('href');
            if (next) next = new URL(next, response.url).href;
            const link = this.querySelector('[data-ve-next]');
            if (link && next) link.href = next;
            this.refresh();
          }
          if (!signal.aborted && !next && !this.querySelector('[data-ve-previous]')) this.querySelector('[data-ve-pagination]').hidden = true;
        } catch (error) {
          if (error.name !== 'AbortError') this.querySelector('[data-ve-pagination]').hidden = false;
        }
      }
      openCalendar(card) {
        if (!card.veDate || card.veDate <= new Date()) return;
        const stamp = date => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
        const escape = text => (text || '').replace(/\\/g, '\\\\').replace(/\r?\n|\r/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
        const fold = line => {
          let out = '', length = 0;
          for (const char of line) {
            const bytes = new TextEncoder().encode(char).length;
            if (length + bytes > 75) { out += '\r\n '; length = 1; }
            out += char; length += bytes;
          }
          return out;
        };
        const url = new URL(location.pathname, location.origin); url.hash = card.id;
        const start = stamp(card.veDate);
        const content = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Volt Music Store//Events//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT', `UID:volt-event-${card.dataset.veId}@voltmusicstore.com`, `DTSTAMP:${stamp(new Date())}`, `DTSTART:${start}`, `SUMMARY:${escape(card.dataset.veTitle)}`, `LOCATION:${escape(card.dataset.veLocation)}`, `DESCRIPTION:${escape(card.dataset.veDescription)}`, `URL:${url.href}`, 'END:VEVENT', 'END:VCALENDAR'].map(fold).join('\r\n') + '\r\n';
        if (this.blobURL) URL.revokeObjectURL(this.blobURL);
        this.blobURL = URL.createObjectURL(new Blob([content], { type: 'text/calendar;charset=utf-8' }));
        const ics = this.querySelector('[data-ve-ics]');
        ics.href = this.blobURL;
        ics.download = `${card.id || 'volt-event'}.ics`;
        const parameters = new URLSearchParams({ action: 'TEMPLATE', text: card.dataset.veTitle, dates: `${start}/${start}`, details: `${card.dataset.veDescription}\n${url.href}`, location: card.dataset.veLocation, ctz: this.zone });
        this.querySelector('[data-ve-google]').href = `https://calendar.google.com/calendar/render?${parameters}`;
        this.querySelector('[data-ve-calendar-title]').textContent = card.dataset.veTitle;
        this.dialog.showModal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volt-full-width-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('volt-hero-slider')) {
    customElements.define('volt-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        this.width = window.innerWidth;
        this.querySelector('[data-controls]')?.removeAttribute('hidden');
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.dataset.go !== undefined) this.show(Number(button.dataset.go));
          if (button.dataset.direction) this.show(this.index + Number(button.dataset.direction));
        }, options);
        this.addEventListener('keydown', event => {
          if (event.target.closest('[data-copy]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'Home') this.show(0);
          else if (event.key === 'End') this.show(this.slides.length - 1);
          else this.show(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
        }, options);
        this.addEventListener('pointerdown', event => {
          this.touch = event.pointerType === 'touch' && !event.target.closest('a, button') ? [event.clientX, event.clientY] : null;
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.touch) return;
          const [x, y] = this.touch;
          const delta = event.clientX - x;
          if (Math.abs(delta) > 60 && Math.abs(delta) > Math.abs(event.clientY - y) * 1.5) this.show(this.index + (delta < 0 ? 1 : -1));
          this.touch = null;
        }, options);
        this.addEventListener('pointercancel', () => { this.touch = null; }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index);
        }, options);
        window.addEventListener('resize', () => {
          if (this.width === window.innerWidth) return;
          this.width = window.innerWidth;
          const header = [...document.querySelectorAll('.shopify-section-group-header-group')].reduce((sum, el) => sum + el.offsetHeight, 0);
          const top = this.getBoundingClientRect().top + window.scrollY;
          this.style.setProperty('--vhs-offset', `${Math.max(0, top < window.innerHeight * .6 ? top : header)}px`);
        }, options);
        this.show(0, false);
      }
      disconnectedCallback() { this.controller?.abort(); }
      show(index, announce = true) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, current) => {
          const active = current === this.index;
          if (!active && slide.contains(document.activeElement)) this.querySelector('[data-direction="1"]')?.focus();
          slide.hidden = !active;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, current) => {
          if (current === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides[this.index].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        const copy = this.slides[this.index].querySelector('[data-copy]');
        if (copy) copy.tabIndex = 0;
        if (announce) this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-payment-meth-2"]) return;
  try {
    
if(!customElements.get('volt-payment-guide'))customElements.define('volt-payment-guide',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const select=this.querySelector('select');if(!select)return;
const country=this.dataset.country;select.value=[...select.options].some(o=>o.value===country)?country:'XX';
const update=()=>{this.querySelector('[data-payment-country-title]').textContent=select.selectedOptions[0].textContent;
this.querySelector('[data-payment-fallback]').hidden=select.value!=='XX';
this.querySelectorAll('[data-payment-method]').forEach(e=>{const codes=e.dataset.paymentCountries.split(',');e.hidden=!codes.includes('*')&&!codes.includes(select.value)});
this.querySelectorAll('[data-payment-group]').forEach(e=>e.hidden=![...e.querySelectorAll('[data-payment-method]')].some(m=>!m.hidden));};
select.addEventListener('change',update);update();
const wrapper=document.createElement('div');wrapper.className='vpg-country-search';
const input=document.createElement('input');input.className='va-select';input.type='text';input.id=select.id+'-search';input.autocomplete='off';input.spellcheck=false;
input.setAttribute('role','combobox');input.setAttribute('aria-autocomplete','list');input.setAttribute('aria-expanded','false');input.setAttribute('aria-haspopup','listbox');
const list=document.createElement('div');list.className='vpg-country-options';list.id=input.id+'-options';list.setAttribute('role','listbox');list.hidden=true;input.setAttribute('aria-controls',list.id);
const isDutch=document.documentElement.lang.startsWith('nl');input.placeholder=isDutch?'Zoek een land':'Search countries';list.setAttribute('aria-label',isDutch?'Landen':'Countries');
select.before(wrapper);wrapper.append(input,list);select.hidden=true;this.querySelector('label[for="'+select.id+'"]').htmlFor=input.id;
const options=[...select.options].map(o=>({value:o.value,label:o.textContent}));let matches=[],active=-1,pressed=null;
const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
const restore=()=>input.value=select.selectedOptions[0].textContent;
const outside=e=>{if(!wrapper.contains(e.target)){pressed=null;close()}};
const close=()=>{document.removeEventListener('pointerdown',outside);list.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');active=-1;restore()};
const choose=o=>{select.value=o.value;select.dispatchEvent(new Event('change',{bubbles:true}));close()};
const highlight=index=>{active=index;[...list.querySelectorAll('[role="option"]')].forEach((e,i)=>{e.classList.toggle('is-active',i===active);e.setAttribute('aria-selected',String(matches[i].value===select.value))});if(active>=0){input.setAttribute('aria-activedescendant',list.children[active].id);list.children[active].scrollIntoView({block:'nearest'})}else input.removeAttribute('aria-activedescendant')};
const render=query=>{list.replaceChildren();matches=options.filter(o=>normalize(o.label+' '+o.value).includes(normalize(query)));active=-1;
matches.forEach((o,i)=>{const item=document.createElement('div');item.className='vpg-country-option';item.id=list.id+'-'+o.value;item.setAttribute('role','option');item.setAttribute('aria-selected',String(o.value===select.value));item.textContent=o.label;let handledAt=0;item.addEventListener('pointerdown',e=>{handledAt=0;pressed={id:e.pointerId,x:e.clientX,y:e.clientY,scroll:list.scrollTop,moved:false};if(e.pointerType!=='touch')e.preventDefault()});item.addEventListener('pointermove',e=>{if(pressed&&Math.hypot(e.clientX-pressed.x,e.clientY-pressed.y)>10)pressed.moved=true});item.addEventListener('pointerup',e=>{handledAt=Date.now();const tap=pressed&&pressed.id===e.pointerId&&!pressed.moved&&Math.hypot(e.clientX-pressed.x,e.clientY-pressed.y)<=10&&Math.abs(list.scrollTop-pressed.scroll)<5;pressed=null;if(tap){e.preventDefault();choose(o);if(e.pointerType==='touch')input.blur()}});item.addEventListener('pointercancel',()=>{pressed=null;handledAt=Date.now()});item.addEventListener('click',()=>{if(Date.now()-handledAt>500)choose(o)});list.append(item)});
if(!matches.length){const empty=document.createElement('div');empty.className='vpg-country-empty';empty.setAttribute('role','status');empty.textContent=isDutch?'Geen landen gevonden':'No countries found';list.append(empty)}list.hidden=false;document.addEventListener('pointerdown',outside);input.setAttribute('aria-expanded','true');input.removeAttribute('aria-activedescendant')};
input.addEventListener('focus',()=>{render('');input.select()});input.addEventListener('click',()=>{if(list.hidden){render('');input.select()}});input.addEventListener('input',()=>render(input.value));
input.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();close()}else if(e.key==='Tab'){close()}else if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();if(list.hidden)render('');if(matches.length)highlight((active+(e.key==='ArrowDown'?1:-1)+matches.length)%matches.length)}else if(e.key==='Enter'){e.preventDefault();if(!list.hidden&&matches.length)choose(matches[active<0?0:active])}});
input.addEventListener('blur',()=>{if(!pressed)close()});restore();}

});

  } catch(e) { console.error(e); }
})();
})();
